/**
 * 货币千分位格式化 / 该函数参数可传一个对象({ number: 1 })，也可以是平铺开的参数(number)
 * @param  {Number} number   数字
 * @param  {Number} places   保留小数后几位
 * @param  {String} symbol   数字前面的符号
 * @param  {String} thousand [description]
 * @param  {String} decimal  [description]
 * @return {[type]}          格式化后的金额
 * @文档地址 https://gtcloud.yuque.com/asfzgp/trhc08/gnp1ur#eRSqX
 */
function formatMoney(config) {
  var number = 0,
      places = 2,
      symbol = '￥',
      thousand = ',',
      decimal = '.';

  if (typeof config == "object") {
    var _config$number = config.number,
        number_ = _config$number === void 0 ? 0 : _config$number,
        _config$places = config.places,
        places_ = _config$places === void 0 ? 2 : _config$places,
        _config$symbol = config.symbol,
        symbol_ = _config$symbol === void 0 ? '￥' : _config$symbol,
        _config$thousand = config.thousand,
        thousand_ = _config$thousand === void 0 ? ',' : _config$thousand,
        _config$decimal = config.decimal,
        decimal_ = _config$decimal === void 0 ? '.' : _config$decimal;
    number = number_;
    places = places_;
    symbol = symbol_ === false ? '' : symbol_;
    thousand = thousand_;
    decimal = decimal_;
  } else {
    number = arguments[0] || 0;
    places = arguments[1] || 2;
    symbol = arguments[2] === false ? '' : '￥';
    thousand = arguments[3] || ',';
    decimal = arguments[4] || '.';
  }

  if (isNaN(number)) return '';
  var negative = number < 0 ? '-' : '';
  var i = parseInt(Math.abs(number).toFixed(places), 10).toString();
  var j = i.length > 3 ? i.length % 3 : 0;
  return symbol + negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + (Math.abs(number) - i).toFixed(places).slice(2) : '');
}

export default formatMoney;